import { type ReactNode } from 'react';

import { YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { TEXT_STYLE } from '../tokens';

import { FieldError } from './FieldError';
import { FieldLabel } from './FieldLabel';

// A label above its control, for long-form text that needs the full width
export const StackedField = ({
  id,
  label,
  labelsControl,
  error,
  labelHidden,
  children,
}: {
  id: string;
  label: string | undefined;
  labelsControl: boolean;
  error: string | undefined;
  labelHidden?: boolean;
  children: ReactNode;
}) => (
  <YStack className="min-w-0 gap-[calc(2*var(--ac-u))]">
    {label ? (
      <FieldLabel
        id={id}
        labelsControl={labelsControl}
        text={label}
        className={cn(TEXT_STYLE.meta, 'text-foreground-muted')}
        hidden={labelHidden}
      />
    ) : null}
    {children}
    <FieldError id={id} error={error} />
  </YStack>
);
